import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  inject,
  OnInit,
  QueryList,
  ViewChildren,
  ViewContainerRef
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomHostDirective } from 'gung-list';
import { ProductConcept } from '../../models';
import { BaseViewConfigService } from '../../services/base-view-config/base-view-config.service';
import { CartService } from '../../services/cart/cart.service';
import { ConceptDetailProductListV2ConfigService } from '../../services/concept-detail-product-list-v2-config/concept-detail-product-list-v2-config.service';
import { MergedI18nService } from '../../services/mergedi18n/merged-i18n.service';
import { ProductMatrixModalService } from '../../services/product-matrix-modal/product-matrix-modal.service';
import { SelectedCustomerService } from '../../services/selected-customer/selected-customer.service';
import { ConceptDetailV2TopDetailsComponent } from '../concept-detail-v2-top-details/concept-detail-v2-top-details.component';
import { ProductDetailV2Component } from '../product-detail-v2/product-detail-v2.component';

@Component({
  selector: 'lib-concept-detail-v2',
  templateUrl: './concept-detail-v2.component.html',
  styleUrls: ['./concept-detail-v2.component.css'],
  standalone: false
})
export class ConceptDetailV2Component extends ProductDetailV2Component implements AfterViewInit, OnInit {
  @ViewChildren(CustomHostDirective)
  private viewChildren: QueryList<CustomHostDirective>;

  product: ProductConcept;
  public showConceptDetails: boolean;

  protected productMatrixModalService = inject(ProductMatrixModalService);
  protected mergedI18nService = inject(MergedI18nService);
  protected selectedCustomerService = inject(SelectedCustomerService);
  protected modalService = inject(NgbModal);
  protected cartService = inject(CartService);
  protected baseViewConfigService = inject(BaseViewConfigService);
  public configService = inject(ConceptDetailProductListV2ConfigService);
  protected componentFactoryResolver = inject(ComponentFactoryResolver);

  ngOnInit(): void {
    super.ngOnInit();
    this.showConceptDetails = !!this.baseViewConfigService?.getConceptDetailV2ProductListViewComponent?.();
    if (!!this.viewChildren && !!this.viewChildren.first) {
      this.renderItemComponent(this.viewChildren.first.viewContainerRef);
    }
  }
  ngAfterViewInit(): void {
    /*
      pushed to oninit to remove error If doesn't work in some project try uncomment this
    */
    if (!!this.viewChildren && !!this.viewChildren.first) {
      this.renderItemComponent(this.viewChildren.first.viewContainerRef);
    }
  }
  protected mapData(product, availability, price, user, flow) {
    this.configService.conceptProduct = product;
    super.mapData(product, availability, price, user, flow);
    if (!!this.viewChildren && !!this.viewChildren.first) {
      this.renderItemComponent(this.viewChildren.first.viewContainerRef);
    }
  }

  renderItemComponent(containerRef: ViewContainerRef) {
    containerRef.clear();
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      this.baseViewConfigService.getConceptDetailTopDetailsComponent()
    );
    const componentRef = containerRef.createComponent(factory);
    const typed = componentRef.instance as ConceptDetailV2TopDetailsComponent; // maybe have any here?
    typed.concept = this.product;
  }
}
